export const SEARCH_PARAMS_TO_OMIT_FOR_SEARCHES = [
  'layout',
  'selectedOfferId',
  'redirectId',
  'closeSearchBox',
  'offerFilters',
  'roomFilters'
]
